import { RG_TYPE } from '../../types/rg-type.js';

/**
 * Calculates the thickness of the external wall of the modules of this
 * apartment
 * @param obj the input apartment
 * @returns the thickness
 */
function getModuleWallThicknessFromApartment(obj) {
    const module = obj.children.filter(c => c.type === RG_TYPE.Module)[0];
    const walls = module.children.filter(c => c.type === RG_TYPE.Wall);
    const max = Math.max(...walls.map(w => w.pos[2]));
    return walls.filter(w => w.pos[2] === max)[0].size[2];
}

export { getModuleWallThicknessFromApartment };
//# sourceMappingURL=get-module-wall-thickness-from-apartment.js.map
